module.exports = __webpack_public_path__ + "static/media/mapa.58d84a0a.png";